const initialState = {};
export function homepage(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
